<template>
    <page-container>
        <page-header>
            Entry Points
            <template v-slot:actions>
                <analytics-controls v-model="controls" />
            </template>
        </page-header>

        <div class="grid gap-6 grid-cols-1 lg:grid-cols-12">
            <analytics-contacts-total-active-entry-points class="lg:col-span-4" />

            <analytics-contacts-total-created
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-contacts-total-created>

            <analytics-marketing-subscriptions-total-by-status class="lg:col-span-4" />

            <analytics-contacts-total-created-by-entry-point
                class="lg:col-span-12"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-contacts-total-created-by-entry-point>

            <analytics-marketing-subscriptions-total-by-status class="lg:col-span-4" status="opt_in" />

            <analytics-marketing-subscriptions-total-opt-ins
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-marketing-subscriptions-total-opt-ins>

            <analytics-marketing-subscriptions-total-opt-outs
                class="lg:col-span-4"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-marketing-subscriptions-total-opt-outs>

            <analytics-marketing-subscriptions-total-opt-ins-by-entry-point
                class="lg:col-span-12"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-marketing-subscriptions-total-opt-ins-by-entry-point>

            <analytics-marketing-subscriptions-total-opt-outs-by-entry-point
                class="lg:col-span-12"
                :startDate="controls.start_date"
                :endDate="controls.end_date"
            >
            </analytics-marketing-subscriptions-total-opt-outs-by-entry-point>
        </div>
    </page-container>
</template>
<script setup>
import { ref } from 'vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import AnalyticsControls from './partial/AnalyticsControls.vue';
import AnalyticsContactsTotalActiveEntryPoints from './charts/current/AnalyticsContactsTotalActiveEntryPoints.vue';
import AnalyticsMarketingSubscriptionsTotalByStatus from './charts/current/AnalyticsMarketingSubscriptionsTotalByStatus.vue';
import AnalyticsContactsTotalCreatedByEntryPoint from './charts/time-series/AnalyticsContactsTotalCreatedByEntryPoint.vue';
import AnalyticsContactsTotalCreated from './charts/time-series/AnalyticsContactsTotalCreated.vue';
import AnalyticsMarketingSubscriptionsTotalOptIns from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptIns.vue';
import AnalyticsMarketingSubscriptionsTotalOptOuts from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptOuts.vue';
import AnalyticsMarketingSubscriptionsTotalOptInsByEntryPoint from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptInsByEntryPoint.vue';
import AnalyticsMarketingSubscriptionsTotalOptOutsByEntryPoint from './charts/time-series/AnalyticsMarketingSubscriptionsTotalOptOutsByEntryPoint.vue';
import { controlDateRangeOptions } from '../../utils/analytics';

const controls = ref(controlDateRangeOptions().find((option) => option.value === 'last_30_days'));
</script>
